<template>
  <div id="SectionReportingCompliance">
    <UIContainer class="SectionReportingCompliance__container">
      <template #left>
        <img
          class="SectionReportingCompliance__image"
          :src="reportingImage"
          alt="Reporting, Compliance & XBRL"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionReportingCompliance__content">
          <SectionTitle titleSize="sm">
            <template #title> Reporting, Compliance & XBRL </template>

            <template #description>
              Map once, reuse everywhere - from CSRD to EcoVadis to state-level
              asks then file in iXBRL with automated checks.
            </template>
          </SectionTitle>

          <div class="SectionReportingCompliance__features">
            <div
              class="SectionReportingCompliance__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionReportingCompliance__feature-icon"
                name="checkCircleOutline"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <!--<div class="SectionReportingCompliance__cta">
            <UIButton size="xl" theme="primary" buttonStyle="pale">
              Learn more

              <template #icon-after>
                <UIIcon name="arrowLink" />
              </template>
            </UIButton>
          </div>-->
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
// import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
import reportingImage from '../assets/reportingCompliance/reportingCompliance.avif'

const features = [
  'ESRS/ISSB/GRI/SASB mapping',
  'EU Taxonomy tags',
  'CA SB-253/261 data views',
  'iXBRL export with validation',
]
</script>

<style lang="scss" scoped>
#SectionReportingCompliance {
  position: relative;

  :deep(.UIContainer__left) {
    display: flex;
    justify-content: flex-end;
  }

  .SectionReportingCompliance__container {
    padding-top: 0;
  }

  .SectionReportingCompliance__image {
    display: none;

    @include md {
      display: block;
    }
  }

  .SectionReportingCompliance__content {
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionReportingCompliance__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionReportingCompliance__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionReportingCompliance__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionReportingCompliance__feature-icon {
    --size: 1.75rem;
  }

  .SectionReportingCompliance__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
